<div class="text-center py-3" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div *ngIf="!loading">
  <table class="table">
    <tbody>
      <tr>
        <td colspan="3" class="text-center">
          <a [routerLink]="'/events'" [queryParams]="{ new_event: true, matter_id: matter_id }">Create New Event</a>
        </td>
      </tr>
      <tr *ngIf="count > 0">
        <td colspan="3" class="text-center">
          <div class="text-center pagination-small-margin pagination-center">
            <pagination
              [boundaryLinks]="true"
              [totalItems]="count"
              [(ngModel)]="searchParams.page"
              (pageChanged)="pageChanged($event)"
              class="pagination-sm"
              [itemsPerPage]="searchOptions.per_page"
              [maxSize]="3"
              previousText="&lsaquo;"
              nextText="&rsaquo;"
              firstText="&laquo;"
              lastText="&raquo;"
            ></pagination>
          </div>
        </td>
      </tr>
      <tr *ngFor="let event of events">
        <td>
          <a [routerLink]="'/events'" [queryParams]="{ edit_event_id: event.id, matter_id: matter_id }" tooltip="Edit" title="Edit">
            <i class="fas fa-pencil-alt"></i>
          </a>
        </td>
        <td>
          <a [routerLink]="'/events'" [queryParams]="{ show_event_id: event.id }" [tooltip]="event.title" [title]="event.title">{{ event.start_time }}</a>
        </td>
        <td [innerHTML]="event.notes | safeHtml"></td>
      </tr>
      <tr *ngIf="count > 0">
        <td colspan="3" class="text-center">
          <div class="text-center pagination-small-margin pagination-center">
            <pagination
              [boundaryLinks]="true"
              [totalItems]="count"
              [(ngModel)]="searchParams.page"
              (pageChanged)="pageChanged($event)"
              class="pagination-sm"
              [itemsPerPage]="searchOptions.per_page"
              [maxSize]="3"
              previousText="&lsaquo;"
              nextText="&rsaquo;"
              firstText="&laquo;"
              lastText="&raquo;"
            ></pagination>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="text-center">
          <a [routerLink]="'/events'" [queryParams]="{ new_event: true, matter_id: matter_id }">Create New Event</a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
